/**
 * Created by Administrador on 20/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('urgents', {
                parent: 'app',
                url: '/urgents',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/urgent/urgents.html',
                        controller: 'urgentCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['urgent']);
                            }],
                            urgents: ['urgentService', function (urgentService) {
                                return urgentService.getUrgentList();
                            }]
                        }
                    }
                }
            })
            .state('urgentNew', {
                parent: 'app',
                url: '/urgent/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/urgent/newUrgent.html',
                        controller: 'newEditUrgentCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('urgents')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['urgent']);
                            }],
                            action: [function () {
                                return "new";
                            }],
                            urgent: [function () {
                                return null;
                            }]
                        }
                    }
                }
            })
            .state('urgentDelete', {
                parent: 'urgents',
                url: '/urgent/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/urgent/deleteUrgent.html',
                        controller: 'deleteUrgentCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            urgent: ['urgentService', function (urgentService) {
                                return urgentService.getUrgent($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['urgent']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('urgents', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
